import { Injectable, computed, inject, signal, InjectionToken } from '@angular/core';
import { StorageService } from '@base/lib/core/services/storage';

const CURRENT_ROLE_KEY = 'current_role';

export type BaseRole = 'HealthAdm' | 'Cooperator' | 'Doctor' | 'Citizen';
export type Role = BaseRole | (string & {});

export const permissionList = [
  // 首頁
  'HomePage.LatestNews:View',
  'HomePage.HealthActivities:View',
  'HomePage.Calendar:View',
  'HomePage.TodoList:View',
  // 資料管理
  'DataManagement.CaseQualificationsManagement:View',
  'DataManagement.CaseQualificationsManagement:Create',
  'DataManagement.CaseQualificationsManagement:Edit',
  'DataManagement.CaseQualificationsManagement:Delete',
  // 醫療團隊
  'MedicalTeam.MedicalOrganizationManagement:View',
  'MedicalTeam.MedicalOrganizationManagement:Create',
  'MedicalTeam.MedicalOrganizationManagement:Edit',
  'MedicalTeam.MedicalOrganizationManagement:Delete',
  'MedicalTeam.HealthManagementStation:View',
  'MedicalTeam.HealthManagementStation:Create',
  'MedicalTeam.HealthManagementStation:Edit',
  'MedicalTeam.HealthManagementStation:Delete',
  'MedicalTeam.PhraseMaintenance:View',
  'MedicalTeam.PhraseMaintenance:Create',
  'MedicalTeam.PhraseMaintenance:Edit',
  'MedicalTeam.PhraseMaintenance:Delete',
  // 個案管理
  'MembershipManagement.MemberData:View',
  'MembershipManagement.MemberData:Create',
  'MembershipManagement.MemberData:Edit',
  'MembershipManagement.MemberData:Delete',
  'MembershipManagement.VisitRecordManagement:View',
  'MembershipManagement.VisitRecordManagement:Create',
  'MembershipManagement.VisitRecordManagement:Edit',
  'MembershipManagement.VisitRecordManagement:Delete',
  'MembershipManagement.VideoCareManagement:View',
  'MembershipManagement.VideoCareManagement:Create',
  'MembershipManagement.VideoCareManagement:Edit',
  'MembershipManagement.VideoCareManagement:Delete',
  'MembershipManagement.VideoConsultationManagement:View',
  'MembershipManagement.VideoConsultationManagement:Create',
  'MembershipManagement.VideoConsultationManagement:Edit',
  'MembershipManagement.VideoConsultationManagement:Delete',
  'MembershipManagement.MembershipChangeRequest:View',
  'MembershipManagement.MembershipChangeRequest:Create',
  'MembershipManagement.MembershipChangeRequest:Edit',
  'MembershipManagement.MembershipChangeRequest:Delete',
  'MembershipManagement.PhysiologicalMeasurementInformation:View',
  'MembershipManagement.PhysiologicalMeasurementInformation:Create',
  'MembershipManagement.PhysiologicalMeasurementInformation:Edit',
  'MembershipManagement.PhysiologicalMeasurementInformation:Delete',
  // 指標平台
  'IndicatorPlatform.healthStatusStatistics:View',
  'IndicatorPlatform.healthStatusStatistics:Create',
  'IndicatorPlatform.healthStatusStatistics:Edit',
  'IndicatorPlatform.healthStatusStatistics:Delete',
  'IndicatorPlatform.MemberHealthManagementTracking:View',
  'IndicatorPlatform.MemberHealthManagementTracking:Create',
  'IndicatorPlatform.MemberHealthManagementTracking:Edit',
  'IndicatorPlatform.MemberHealthManagementTracking:Delete',
  'IndicatorPlatform.AdultHealthCheckManagement:View',
  'IndicatorPlatform.AdultHealthCheckManagement:Create',
  'IndicatorPlatform.AdultHealthCheckManagement:Edit',
  'IndicatorPlatform.AdultHealthCheckManagement:Delete',
  // 轉介服務
  'ReferralService.CaseTracking:View',
  'ReferralService.CaseTracking:Create',
  'ReferralService.CaseTracking:Edit',
  'ReferralService.CaseTracking:Delete',
  // 業務管理
  'BusinessManagement.OnlineHealthConsultation:View',
  'BusinessManagement.OnlineHealthConsultation:Create',
  'BusinessManagement.OnlineHealthConsultation:Edit',
  'BusinessManagement.OnlineHealthConsultation:Delete',
  'BusinessManagement.CaseApproval:View',
  'BusinessManagement.CaseApproval:Create',
  'BusinessManagement.CaseApproval:Edit',
  'BusinessManagement.CaseApproval:Delete',
  // 院內綜合評估
  // "InternalComprehensiveEvalution.FormAnalysis:View",
  // "InternalComprehensiveEvalution.FormManagement:View",
  // "InternalComprehensiveEvalution.FormManagement:Create",
  // "InternalComprehensiveEvalution.FormManagement:Edit",
  // "InternalComprehensiveEvalution.FormManagement:Delete",
  // "InternalComprehensiveEvalution.Form:View",
  // "InternalComprehensiveEvalution.Form:Create",
  // "InternalComprehensiveEvalution.Form:Edit",
  // "InternalComprehensiveEvalution.Form:Delete",
  // 綜合評估
  'CareComprehensiveAssessment.ComprehensiveEvaluationRecord:View',
  'CareComprehensiveAssessment.ComprehensiveEvaluationRecord:Create',
  'CareComprehensiveAssessment.ComprehensiveEvaluationRecord:Edit',
  'CareComprehensiveAssessment.ComprehensiveEvaluationRecord:Delete',
  'CareComprehensiveAssessment.ComprehensiveEvaluationWrite:View',
  'CareComprehensiveAssessment.ComprehensiveEvaluationWrite:Create',
  'CareComprehensiveAssessment.ComprehensiveEvaluationWrite:Edit',
  'CareComprehensiveAssessment.ComprehensiveEvaluationWrite:Delete',
  'CareComprehensiveAssessment.ComprehensiveEvaluationManagement:View',
  'CareComprehensiveAssessment.ComprehensiveEvaluationManagement:Create',
  'CareComprehensiveAssessment.ComprehensiveEvaluationManagement:Edit',
  'CareComprehensiveAssessment.ComprehensiveEvaluationManagement:Delete',
  'CareComprehensiveAssessment.ComprehensiveEvaluationForm:View',
  'CareComprehensiveAssessment.ComprehensiveEvaluationForm:Create',
  'CareComprehensiveAssessment.ComprehensiveEvaluationForm:Edit',
  'CareComprehensiveAssessment.ComprehensiveEvaluationForm:Delete',
  // 公告資訊管理
  'AnnouncementManagement.HealthEducationConsultingManagement:View',
  'AnnouncementManagement.HealthEducationConsultingManagement:Create',
  'AnnouncementManagement.HealthEducationConsultingManagement:Edit',
  'AnnouncementManagement.HealthEducationConsultingManagement:Delete',
  'AnnouncementManagement.HealthManagementStation:View',
  // 'AnnouncementManagement.HealthManagementStation:Create',
  // 'AnnouncementManagement.HealthManagementStation:Edit',
  // 'AnnouncementManagement.HealthManagementStation:Delete',
  'AnnouncementManagement.FAQ:View',
  'AnnouncementManagement.FAQ:Create',
  'AnnouncementManagement.FAQ:Edit',
  'AnnouncementManagement.FAQ:Delete',
  'AnnouncementManagement.ServiceResource:View',
  'AnnouncementManagement.ServiceResource:Create',
  'AnnouncementManagement.ServiceResource:Edit',
  'AnnouncementManagement.ServiceResource:Delete',
  'AnnouncementManagement.LatestNewsMaintenance:View',
  'AnnouncementManagement.LatestNewsMaintenance:Create',
  'AnnouncementManagement.LatestNewsMaintenance:Edit',
  'AnnouncementManagement.LatestNewsMaintenance:Delete',
  'AnnouncementManagement.OnlineAppointment:View',
  'AnnouncementManagement.OnlineAppointment:Create',
  'AnnouncementManagement.OnlineAppointment:Edit',
  'AnnouncementManagement.OnlineAppointment:Delete',
  'AnnouncementManagement.ConsultKeywordSettings:View',
  'AnnouncementManagement.ConsultKeywordSettings:Create',
  'AnnouncementManagement.ConsultKeywordSettings:Edit',
  'AnnouncementManagement.ConsultKeywordSettings:Delete',
  // 系統管理
  'SystemManagement.AccountInformationManagement:View',
  'SystemManagement.AccountInformationManagement:Create',
  'SystemManagement.AccountInformationManagement:Edit',
  'SystemManagement.AccountInformationManagement:Delete',
  'SystemManagement.RoleMaintenance:View',
  'SystemManagement.RoleMaintenance:Create',
  'SystemManagement.RoleMaintenance:Edit',
  'SystemManagement.RoleMaintenance:Delete',
  'SystemManagement.OperationHistoryManagement:View',
  'SystemManagement.OperationHistoryManagement:Create',
  'SystemManagement.OperationHistoryManagement:Edit',
  'SystemManagement.OperationHistoryManagement:Delete',
  // 訊息管理
  'NotificationManagement.NotificationCenter:View',
  'NotificationManagement.NotificationCenter:Create',
  'NotificationManagement.NotificationCenter:Edit',
  'NotificationManagement.NotificationCenter:Delete',
  'NotificationManagement.SMSPlatform:View',
  'NotificationManagement.SMSPlatform:Create',
  'NotificationManagement.SMSPlatform:Edit',
  'NotificationManagement.SMSPlatform:Delete',
  'NotificationManagement.HealthEducationDelivery:View',
  'NotificationManagement.HealthEducationDelivery:Create',
  'NotificationManagement.HealthEducationDelivery:Edit',
  'NotificationManagement.HealthEducationDelivery:Delete',
  'NotificationManagement.OnlineHealthConsultation:View',
  'NotificationManagement.OnlineHealthConsultation:Create',
  'NotificationManagement.OnlineHealthConsultation:Edit',
  'NotificationManagement.OnlineHealthConsultation:Delete',
  // 個人健康管理
  'PersonalHealth.PersonalMeasurementRecord:View',
  'PersonalHealth.PersonalMeasurementRecord:Create',
  'PersonalHealth.PersonalMeasurementRecord:Edit',
  'PersonalHealth.PersonalMeasurementRecord:Delete',
  'PersonalHealth.MedicationReminder:View',
  'PersonalHealth.MedicationReminder:Create',
  'PersonalHealth.MedicationReminder:Edit',
  'PersonalHealth.MedicationReminder:Delete',
  'PersonalHealth.HealthRiskAssessment:View',
  'PersonalHealth.HealthRiskAssessment:Create',
  'PersonalHealth.HealthRiskAssessment:Edit',
  'PersonalHealth.HealthRiskAssessment:Delete',
  // 個人資料
  'PersonalInfomationManagement.PersonalInfomation:View',
  'PersonalInfomationManagement.PersonalInfomation:Create',
  'PersonalInfomationManagement.PersonalInfomation:Edit',
  'PersonalInfomationManagement.PersonalInfomation:Delete',
  'PersonalInfomationManagement.ChangePassword:View',
  'PersonalInfomationManagement.ChangePassword:Create',
  'PersonalInfomationManagement.ChangePassword:Edit',
  'PersonalInfomationManagement.ChangePassword:Delete',
  'PersonalInfomationManagement.TrackingIdentityCategory:View',
  'PersonalInfomationManagement.TrackingIdentityCategory:Create',
  'PersonalInfomationManagement.TrackingIdentityCategory:Edit',
  'PersonalInfomationManagement.TrackingIdentityCategory:Delete',
  // 視訊關懷
  'OnlineMeetingsCareManagement.MeetingsTime:View',
  'OnlineMeetingsCareManagement.MeetingsTime:Create',
  'OnlineMeetingsCareManagement.MeetingsTime:Edit',
  'OnlineMeetingsCareManagement.MeetingsTime:Delete',
  'OnlineMeetingsCareManagement.VideoCareManagement:View',
  'OnlineMeetingsCareManagement.VideoCareManagement:Create',
  'OnlineMeetingsCareManagement.VideoCareManagement:Edit',
  'OnlineMeetingsCareManagement.VideoCareManagement:Delete',
] as const;

export type Permission = typeof permissionList[number] | '*' | (string & {});

export const rolePermissions: Partial<Record<Role, Permission[]>> = {
  // 資訊處
  HealthAdm: [
    'HomePage.LatestNews:View',
    'HomePage.HealthActivities:View',
    'HomePage.Calendar:View',
    'HomePage.TodoList:View',
    'DataManagement.CaseQualificationsManagement:View',
    'DataManagement.CaseQualificationsManagement:Create',
    'DataManagement.CaseQualificationsManagement:Edit',
    'MedicalTeam.MedicalOrganizationManagement:View',
    'MedicalTeam.MedicalOrganizationManagement:Create',
    'MedicalTeam.MedicalOrganizationManagement:Edit',
    'MedicalTeam.MedicalOrganizationManagement:Delete',
    'MedicalTeam.HealthManagementStation:View',
    'MedicalTeam.HealthManagementStation:Create',
    'MedicalTeam.HealthManagementStation:Edit',
    'MedicalTeam.HealthManagementStation:Delete',
    'MembershipManagement.MemberData:View',
    'MembershipManagement.MemberData:Create',
    'MembershipManagement.MemberData:Edit',
    'IndicatorPlatform.healthStatusStatistics:View',
    'IndicatorPlatform.MemberHealthManagementTracking:View',
    'IndicatorPlatform.MemberHealthManagementTracking:Edit',
    'IndicatorPlatform.AdultHealthCheckManagement:View',
    'IndicatorPlatform.AdultHealthCheckManagement:Create',
    'IndicatorPlatform.AdultHealthCheckManagement:Edit',
    'IndicatorPlatform.AdultHealthCheckManagement:Delete',
    'BusinessManagement.OnlineHealthConsultation:View',
    'BusinessManagement.OnlineHealthConsultation:Edit',
    'BusinessManagement.CaseApproval:View',
    'BusinessManagement.CaseApproval:Edit',
    'CareComprehensiveAssessment.ComprehensiveEvaluationRecord:View',
    'CareComprehensiveAssessment.ComprehensiveEvaluationRecord:Create',
    'CareComprehensiveAssessment.ComprehensiveEvaluationRecord:Edit',
    'CareComprehensiveAssessment.ComprehensiveEvaluationRecord:Delete',
    'CareComprehensiveAssessment.ComprehensiveEvaluationWrite:View',
    'CareComprehensiveAssessment.ComprehensiveEvaluationWrite:Create',
    'CareComprehensiveAssessment.ComprehensiveEvaluationWrite:Edit',
    'CareComprehensiveAssessment.ComprehensiveEvaluationWrite:Delete',
    'CareComprehensiveAssessment.ComprehensiveEvaluationManagement:View',
    'CareComprehensiveAssessment.ComprehensiveEvaluationManagement:Create',
    'CareComprehensiveAssessment.ComprehensiveEvaluationManagement:Edit',
    'CareComprehensiveAssessment.ComprehensiveEvaluationManagement:Delete',
    'CareComprehensiveAssessment.ComprehensiveEvaluationForm:View',
    'CareComprehensiveAssessment.ComprehensiveEvaluationForm:Create',
    'CareComprehensiveAssessment.ComprehensiveEvaluationForm:Edit',
    'CareComprehensiveAssessment.ComprehensiveEvaluationForm:Delete',
    // "InternalComprehensiveEvalution.FormAnalysis:View",
    // "InternalComprehensiveEvalution.FormManagement:View",
    // "InternalComprehensiveEvalution.Form:View",
    // "InternalComprehensiveEvalution.Form:Create",
    // "InternalComprehensiveEvalution.Form:Edit",
    // "InternalComprehensiveEvalution.Form:Delete",
    'AnnouncementManagement.HealthEducationConsultingManagement:View',
    'AnnouncementManagement.HealthEducationConsultingManagement:Create',
    'AnnouncementManagement.HealthEducationConsultingManagement:Edit',
    'AnnouncementManagement.HealthEducationConsultingManagement:Delete',
    'AnnouncementManagement.HealthManagementStation:View',
    'AnnouncementManagement.FAQ:View',
    'AnnouncementManagement.FAQ:Create',
    'AnnouncementManagement.FAQ:Edit',
    'AnnouncementManagement.FAQ:Delete',
    'AnnouncementManagement.ServiceResource:View',
    'AnnouncementManagement.ServiceResource:Create',
    'AnnouncementManagement.ServiceResource:Edit',
    'AnnouncementManagement.LatestNewsMaintenance:View',
    'AnnouncementManagement.LatestNewsMaintenance:Create',
    'AnnouncementManagement.LatestNewsMaintenance:Edit',
    'AnnouncementManagement.LatestNewsMaintenance:Delete',
    'SystemManagement.AccountInformationManagement:View',
    'SystemManagement.AccountInformationManagement:Create',
    'SystemManagement.AccountInformationManagement:Edit',
    'SystemManagement.AccountInformationManagement:Delete',
    'SystemManagement.RoleMaintenance:View',
    'SystemManagement.OperationHistoryManagement:View',
    'NotificationManagement.NotificationCenter:View',
    'NotificationManagement.NotificationCenter:Delete',
    'NotificationManagement.SMSPlatform:View',
    'NotificationManagement.HealthEducationDelivery:View',
    'NotificationManagement.HealthEducationDelivery:Create',
    'PersonalInfomationManagement.PersonalInfomation:View',
    'PersonalInfomationManagement.PersonalInfomation:Edit',
    'PersonalInfomationManagement.PersonalInfomation:Delete',
    'PersonalInfomationManagement.ChangePassword:View',
    'PersonalInfomationManagement.ChangePassword:Edit',
  ],
  // 個管師
  Cooperator: [
    'HomePage.LatestNews:View',
    'HomePage.HealthActivities:View',
    'HomePage.Calendar:View',
    'HomePage.TodoList:View',
    'MedicalTeam.PhraseMaintenance:View',
    'MedicalTeam.PhraseMaintenance:Create',
    'MedicalTeam.PhraseMaintenance:Edit',
    'MedicalTeam.PhraseMaintenance:Delete',
    'MembershipManagement.MemberData:View',
    'MembershipManagement.MemberData:Create',
    'MembershipManagement.MemberData:Edit',
    'MembershipManagement.MemberData:Delete',
    'MembershipManagement.VisitRecordManagement:View',
    'MembershipManagement.VisitRecordManagement:Create',
    'MembershipManagement.VisitRecordManagement:Edit',
    'MembershipManagement.VisitRecordManagement:Delete',
    'MembershipManagement.VideoCareManagement:View',
    'MembershipManagement.VideoCareManagement:Create',
    'MembershipManagement.VideoCareManagement:Edit',
    'MembershipManagement.VideoCareManagement:Delete',
    'MembershipManagement.VideoConsultationManagement:View',
    'MembershipManagement.VideoConsultationManagement:Create',
    'MembershipManagement.VideoConsultationManagement:Edit',
    'MembershipManagement.VideoConsultationManagement:Delete',
    'MembershipManagement.MembershipChangeRequest:View',
    'MembershipManagement.MembershipChangeRequest:Create',
    'MembershipManagement.MembershipChangeRequest:Edit',
    'MembershipManagement.PhysiologicalMeasurementInformation:View',
    'MembershipManagement.PhysiologicalMeasurementInformation:Create',
    'MembershipManagement.PhysiologicalMeasurementInformation:Edit',
    'MembershipManagement.PhysiologicalMeasurementInformation:Delete',
    'IndicatorPlatform.healthStatusStatistics:View',
    'IndicatorPlatform.MemberHealthManagementTracking:View',
    'IndicatorPlatform.MemberHealthManagementTracking:Edit',
    'IndicatorPlatform.AdultHealthCheckManagement:View',
    'IndicatorPlatform.AdultHealthCheckManagement:Create',
    'ReferralService.CaseTracking:View',
    'ReferralService.CaseTracking:Create',
    'BusinessManagement.OnlineHealthConsultation:View',
    'BusinessManagement.OnlineHealthConsultation:Edit',
    'BusinessManagement.CaseApproval:View',
    'BusinessManagement.CaseApproval:Edit',
    'AnnouncementManagement.HealthEducationConsultingManagement:View',
    'AnnouncementManagement.HealthEducationConsultingManagement:Create',
    'AnnouncementManagement.HealthEducationConsultingManagement:Edit',
    'AnnouncementManagement.HealthEducationConsultingManagement:Delete',
    'AnnouncementManagement.HealthManagementStation:View',
    'AnnouncementManagement.FAQ:View',
    'AnnouncementManagement.ServiceResource:View',
    'AnnouncementManagement.ConsultKeywordSettings:View',
    'AnnouncementManagement.ConsultKeywordSettings:Create',
    'AnnouncementManagement.ConsultKeywordSettings:Edit',
    'AnnouncementManagement.ConsultKeywordSettings:Delete',
    'NotificationManagement.NotificationCenter:View',
    'NotificationManagement.NotificationCenter:Delete',
    'NotificationManagement.HealthEducationDelivery:View',
    'NotificationManagement.HealthEducationDelivery:Create',
    'PersonalInfomationManagement.PersonalInfomation:View',
    'PersonalInfomationManagement.PersonalInfomation:Edit',
    'PersonalInfomationManagement.PersonalInfomation:Delete',
    'PersonalInfomationManagement.ChangePassword:View',
    'PersonalInfomationManagement.ChangePassword:Edit',
    'PersonalInfomationManagement.TrackingIdentityCategory:View',
    'PersonalInfomationManagement.TrackingIdentityCategory:Edit',
    'OnlineMeetingsCareManagement.MeetingsTime:View',
    'OnlineMeetingsCareManagement.MeetingsTime:Edit',
    'CareComprehensiveAssessment.ComprehensiveEvaluationRecord:View',
    'CareComprehensiveAssessment.ComprehensiveEvaluationWrite:View',
    'CareComprehensiveAssessment.ComprehensiveEvaluationManagement:View',
    'CareComprehensiveAssessment.ComprehensiveEvaluationForm:View',
  ],
  // 醫事人員
  Doctor: [
    'HomePage.LatestNews:View',
    'HomePage.HealthActivities:View',
    'HomePage.Calendar:View',
    'HomePage.TodoList:View',
    'IndicatorPlatform.AdultHealthCheckManagement:View',
    'IndicatorPlatform.AdultHealthCheckManagement:Edit',
    'MembershipManagement.VideoCareManagement:View',
    'MembershipManagement.VideoConsultationManagement:View',
    'MembershipManagement.VideoConsultationManagement:Create',
    'MembershipManagement.VideoConsultationManagement:Edit',
    'MembershipManagement.VideoConsultationManagement:Delete',
    'NotificationManagement.NotificationCenter:View',
    'NotificationManagement.NotificationCenter:Delete',
    'PersonalInfomationManagement.PersonalInfomation:View',
    'PersonalInfomationManagement.PersonalInfomation:Edit',
    'PersonalInfomationManagement.PersonalInfomation:Delete',
    'PersonalInfomationManagement.ChangePassword:View',
    'PersonalInfomationManagement.ChangePassword:Edit',
    'OnlineMeetingsCareManagement.MeetingsTime:View',
    'OnlineMeetingsCareManagement.MeetingsTime:Edit',
  ],
  // 民眾
  Citizen: [
    'HomePage.LatestNews:View',
    'HomePage.HealthActivities:View',
    'HomePage.Calendar:View',
    'HomePage.TodoList:View',
    'AnnouncementManagement.HealthManagementStation:View',
    'AnnouncementManagement.FAQ:View',
    'AnnouncementManagement.ServiceResource:View',
    'AnnouncementManagement.OnlineAppointment:View',
    'NotificationManagement.NotificationCenter:View',
    'NotificationManagement.NotificationCenter:Delete',
    'NotificationManagement.OnlineHealthConsultation:View',
    'NotificationManagement.OnlineHealthConsultation:Create',
    'NotificationManagement.OnlineHealthConsultation:Edit',
    'PersonalHealth.PersonalMeasurementRecord:View',
    'PersonalHealth.PersonalMeasurementRecord:Create',
    'PersonalHealth.PersonalMeasurementRecord:Edit',
    'PersonalHealth.PersonalMeasurementRecord:Delete',
    'PersonalHealth.MedicationReminder:View',
    'PersonalHealth.MedicationReminder:Create',
    'PersonalHealth.MedicationReminder:Edit',
    'PersonalHealth.MedicationReminder:Delete',
    'PersonalHealth.HealthRiskAssessment:View',
    'PersonalHealth.HealthRiskAssessment:Create',
    'PersonalInfomationManagement.PersonalInfomation:View',
    'PersonalInfomationManagement.PersonalInfomation:Edit',
    'PersonalInfomationManagement.PersonalInfomation:Delete',
    'PersonalInfomationManagement.ChangePassword:View',
    'PersonalInfomationManagement.ChangePassword:Edit',
    'OnlineMeetingsCareManagement.VideoCareManagement:View',
    'OnlineMeetingsCareManagement.VideoCareManagement:Edit',
  ],
};

export const ROLE_PERMISSIONS = new InjectionToken<Partial<Record<Role, string[]>>>('ROLE_PERMISSIONS');

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private readonly storageService = inject(StorageService);
  readonly customRolePermissions = inject(ROLE_PERMISSIONS, { optional: true });

  readonly rolePermissionsConfig = computed(() => {
    const baseConfig = rolePermissions;
    if (!this.customRolePermissions) {
      return baseConfig;
    }

    const merged = { ...baseConfig };

    for (const [role, permissions] of Object.entries(this.customRolePermissions)) {
      if (permissions) {
        const existingPermissions = merged[role] || [];
        merged[role] = Array.from(new Set([...existingPermissions, ...permissions]));
      }
    }

    return merged;
  });

  private _currentRole = signal<Role>(this.storageService.get<Role>(CURRENT_ROLE_KEY) ?? 'Citizen');
  readonly currentRole = this._currentRole.asReadonly();

  readonly userPermissions = computed(() => {
    const role = this._currentRole();
    const config = this.rolePermissionsConfig();
    return role ? (config[role] || []) : [];
  });

  private patternToRegExp(pattern: string) {
    const regexStr = pattern
      .replace(/[.+^${}()|[\]\\]/g, '\\$&')
      .replace(/\*/g, '.*');

    return new RegExp(`^${regexStr}$`);
  }

  hasRole(role: Role | Role[]) {
    if (Array.isArray(role)) {
      return role.some((r) => this._currentRole() === r);
    }

    return this._currentRole() === role;
  }

  hasPermission(requiredPermission?: string) {
    if (!requiredPermission || requiredPermission === '*') {
      return true;
    }

    const regex = this.patternToRegExp(requiredPermission);

    return this.userPermissions().some((p: string) => {
      return regex.test(p);
    });
  }

  updateCurrentRole(role: Role) {
    this.storageService.set(CURRENT_ROLE_KEY, role);
    this._currentRole.set(role);
  }
}
